export const achievements = [
  {
    title: "Winner - Yarl Xtreme Coding Competition 2024",
    image: "/Achievements/yarlextreme.png",
    description: "first place in the competition, demonstrating strong competitive programming, problem-solving, and time management skills, along with effective teamwork and adaptability under pressure.",
    link: "https://www.linkedin.com/posts/isuru-indrajith-387ab7278_yarlxtreme-codingexcellence-problemsolvers-activity-7249484499967737857-HBnF?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEPLZFcBxoOtvs0Swhj_u3qmdix5634CbYY"
  },
  {
    title: "IEEE Xtreme 18.0.",
    image: "/Achievements/ieee.jpg",
    description: "Secured 116th place in Sri Lanka and 1248th place worldwide",
    link: "https://www.linkedin.com/posts/isuru-indrajith-387ab7278_ieeextreme-codemazer-teamwork-activity-7257820504449851393-YzpJ?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEPLZFcBxoOtvs0Swhj_u3qmdix5634CbYY"
  },
  {
    title: " Postman API Fundamentals Student Expert ",
    image: "/Achievements/Postman - Postman API Fundamentals Student Expert - 2024-11-19 (2).png",
    description: " API development and testing, Authentication.",
    link: "https://badgr.com/public/assertions/9NCsj9yGSluJVCXNqFI7rQ?identity__email=isuruindrajith680@gmail.com"
    },
  {
    title: " Kaggle, Intro to Machine Learning.",
    image: "/Achievements/kaggle.png",
    description: " Machine Learning basics.",
    link: "https://www.kaggle.com/learn/certification/isuruindrajith/intro-to-machine-learning"
    },
  {
    title: "Microsoft Azure Fundamentals",
    image: "/Achievements/microsoft azure.png",
    description: "Describe cloud concepts|Microsoft Learn",
    link: "https://learn.microsoft.com/en-us/users/indrajithemi-2071/?source=docs#account-linking"
  }
];
